<template>
  <v-select
    class="status-select"
    item-text="name"
    item-value="id"
    dense
    hide-details
    :value="String(item.car_status)"
    :items="carStatuses"
    :item-disabled="isDisabled"
    :disabled="disabled"
  >
    <template #item="{ item }">
      <div class="status-select__item" @click="$emit('change', item.id)">
        {{ item.name }}
        <template v-if="daysTillVocation > 0">
          <i v-if="item.id === '8' || item.id === '9'">
            (ост. {{ daysTillVocation }} дн.)
          </i>
        </template>
        <template v-else-if="daysTillVocation === -1">
          <i v-if="item.id === '8' || item.id === '9'">
            (граф. без вых.)
          </i>
        </template>
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    daysTillVocation: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    carStatuses() {
      const statuses = this.$store.state['workers-board'].carStatuses;
      return statuses.filter(({ id }) => id !== '0');
    },
    disabled() {
      const hasNoPermission = !this.$can(
        'workdesk_edit_driver_and_auto_status',
      );
      // eslint-disable-next-line
      const canotBuyoutEdit =
        !this.$can('workdesk_edit_on_buyout') && this.item.car_status === 13;

      return hasNoPermission || canotBuyoutEdit;
    },
  },
  methods: {
    isDisabled({ id }) {
      const isVocation = id === '8' || id === '9';

      if (isVocation && this.daysTillVocation > 0) return true;

      return this.checkIsDriverRequired(id) || this.checkIsVocationDisabled(id);
    },
    checkIsDriverRequired(id) {
      let isDriverRequire = false;

      switch (Number(id)) {
        case 1:
        case 5:
        case 8:
        case 9:
        case 11:
        case 13:
          isDriverRequire = true;
          break;
        default:
          isDriverRequire = false;
      }

      return this.item.driver_id ? !isDriverRequire : isDriverRequire;
    },
    checkIsVocationDisabled(id) {
      const statusId = Number(id);
      const isVocationDay = statusId === 8 || statusId === 9;
      const isVocationAvalible = !this.item.is_vocation;

      if (!isVocationDay) return false;
      return isVocationAvalible;
    },
  },
};
</script>

<style lang="scss">
.status-select {
  width: 120px;
  margin-top: 0;

  .v-select__selection {
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  &__item {
    display: flex;
    align-items: center;

    i {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.38);
      margin-left: 5px;
    }
  }
}
</style>
